<template>
<!-- 改变透明度的组件 -->
  <div id="slider">
    <div class="block" v-show="$store.state.environmentchange">
        <span class="demonstration">管网透视度</span>
        <el-slider v-model="$store.state.tumingvalue" :format-tooltip="formatTooltip" class="my_slider" @input="changeopacity"></el-slider>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // value: 100,
      ifvalue:false
    };
  },
  methods: {
    formatTooltip(val) {
        return val / 100;
    },
    changeopacity() {
        //document.getElementById("iframe").contentWindow.MMAPI.groundbokeh(this.value/100);
        
        if(this.$store.state.tumingvalue<100){
          this.ifvalue=true;
        }         
        if(this.ifvalue){
          document.getElementById("iframe").contentWindow.MMAPI.groundbokeh(this.$store.state.tumingvalue/100);
        }



        // else{
        //   setTimeout(()=>{
        //     document.getElementById("iframe").contentWindow.MMAPI.huifu_1();
        //   },500)
        // }
    }
  },
};
</script>

<style scoped>
#slider {
  width: 12vw;
  height: 5vh;
  /* background: white; */
  overflow: visible;
}
.block {
    width: 95%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.demonstration{
    flex: 1;
    height: 100%;
    line-height: 5vh;
    color: white;
    font-size: 16px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
    -o-user-select: none;
		-moz-user-select: none; /*/火狐 firefox/*/
		-webkit-user-select: none; /*/webkit浏览器/*/
		-ms-user-select: none; /*/IE10+/*/
		-khtml-user-select: none; 
		user-select: none;
}
.my_slider{
    width: 70%;
    flex: 1;
}
</style>